<template>
  <div class="nuttrema-widget nuttrema-widget--videos">
    <template>
      <h4 class="nuttrema-widget__sup_title">{{ $t('label.you_tube') }}</h4>
      <h2 class="nuttrema-widget__title">{{ $t('label.video_tutorials') }}</h2>
      <p class="nuttrema-widget__sub_title">{{ $t('label.watch_diet_creator_screen_cast') }}</p>
      <div class="nuttrema-widget__videos-carousel">
        <iframe width="100%" height="360" :src="`https://www.youtube.com/embed/videoseries?list=${$t('file.youtube_dc_tutorials')}`" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
      </div>
    </template>
  </div>
</template>

<script>
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

import AbstractWidget from './abstract-widget';

export default {
  name: 'widget-videos-carousel',
  mixins: [
    AbstractWidget,
  ],
  components: {
    NuttremaIconicaSidebarLink,
  },
};
</script>

<style lang="scss" scoped>
  @import './abstract-widget';

  .nuttrema-widget__videos-carousel {
    margin-top: 1em;
    iframe {
      margin-bottom: -0.5em !important;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/ui/widgets/widget-videos-carousel.vue